import { render, staticRenderFns } from "./VenueIdam.vue?vue&type=template&id=6b0b20d4&scoped=true&"
import script from "./VenueIdam.vue?vue&type=script&lang=js&"
export * from "./VenueIdam.vue?vue&type=script&lang=js&"
import style0 from "./VenueIdam.vue?vue&type=style&index=0&id=6b0b20d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0b20d4",
  null
  
)

export default component.exports